// extracted by mini-css-extract-plugin
export default {"root":"days-grid_root__xOkNW","week":"days-grid_week__RvnsO","weekSelected":"days-grid_weekSelected__WJ8Ad","placeHolderShimmer":"days-grid_placeHolderShimmer__x0GLJ"};